/*
 * Devices should be sorted in the following order
 * Previously detected devices -> detected devices -> undetected devices
 */

import type { DisplayCue } from "@expert/contentful";

export const sortCues = (devices: DisplayCue[]) => {
    return structuredClone<DisplayCue[]>(devices).sort((a, b) => {
        if (a.isDetectedOnPreviousCall && !b.isDetectedOnPreviousCall) return -1;
        if (!a.isDetectedOnPreviousCall && b.isDetectedOnPreviousCall) return 1;
        if (a.detected && !b.detected) return -1;
        if (!a.detected && b.detected) return 1;
        return 0;
    });
};
